import { useEffect, useRef } from "react";
import { useLocation, useNavigationType } from "react-router-dom";
import * as Sentry from "@sentry/react";

export default function SentryRouteTracker() {
  const location = useLocation();
  const navType = useNavigationType();
  const prevPath = useRef(location.pathname);

  useEffect(() => {
    const to = location.pathname + location.search;
    const from = prevPath.current;
    prevPath.current = to;

    // Add breadcrumb (shows in replays/traces and Discover)
    Sentry.addBreadcrumb({
      category: "navigation",
      level: "info",
      data: { from, to, navType },
      message: `route change: ${from} -> ${to}`,
    });

    // Tag current route on active span/transaction for filtering
    Sentry.setTag("route", location.pathname);

    // Lightweight analytics without creating an Issue:
    // Attach a child span to the current transaction
    Sentry.startSpan({ name: "page_view", op: "ui" }, () => {});
  }, [location, navType]);

  return null;
}